/**
 * Espelha StatusEtapaOrdemProducaoEnum da API.Suprimentos e a tabela status_etapa_ordem_producao.
 */
export enum StatusEtapaOrdemProducaoEnum {
  Pendente = 1,
  EmAndamento = 2,
  Concluida = 3,
}

export const StatusEtapaOrdemProducaoDescricao: { [key: number]: string } = {
  [StatusEtapaOrdemProducaoEnum.Pendente]: 'Pendente',
  [StatusEtapaOrdemProducaoEnum.EmAndamento]: 'Em andamento',
  [StatusEtapaOrdemProducaoEnum.Concluida]: 'Concluída',
};

/** Mesmas classes .badge-* globais do styles.css usadas no status da OP. */
export const StatusEtapaOrdemProducaoBadge: { [key: number]: string } = {
  [StatusEtapaOrdemProducaoEnum.Pendente]: 'badge-cinza',
  [StatusEtapaOrdemProducaoEnum.EmAndamento]: 'badge-azul',
  [StatusEtapaOrdemProducaoEnum.Concluida]: 'badge-verde',
};
